import { render, staticRenderFns } from "./PromocodeGroups.vue?vue&type=template&id=6aacd825&scoped=true"
import script from "./PromocodeGroups.vue?vue&type=script&lang=js"
export * from "./PromocodeGroups.vue?vue&type=script&lang=js"
import style0 from "./PromocodeGroups.vue?vue&type=style&index=0&id=6aacd825&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aacd825",
  null
  
)

export default component.exports